import { baseService } from '@services/base.service';
import { SchoolSearchState } from '@store/SchoolSearchFiltersStore';

import { UserPreferences } from '@common-types';

export async function postSaveFilter(data: Partial<SchoolSearchState>) {
  return baseService.postAsync<UserPreferences, Partial<SchoolSearchState>>(`/user/filters/colleges`, data);
}

export async function deleteSaveFilter(filterId: string) {
  return baseService.deleteAsync<UserPreferences>(`/user/filters/colleges/${filterId}`);
}
